export default __webpack_public_path__ + "static/media/yonghu.08f91a7f.png";